export default "/kiban/_next/static/images/login_image_3-e054da0cbfefabc07cb4e1cb15cf9b0a.jpg";